module.exports = "/_next/static/images/tf-fd20c9ec2c8085e9fbc4043c1ebd080b.svg";